import {newAxiosClient} from './axios';
import {getAccessToken} from '@/utils/token-manager';

export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
  error: boolean;
  error_message: string | null;
}

export const postLogin = async (
  email: string,
  password: string
): Promise<ApiResponse<any>> => {
  return await newAxiosClient.post('/auth/employee-login', {
    email,
    password
  });
};

export const getFirebaseCustomToken = async () => {
  return await newAxiosClient.post('/firebase-admin/employee-token');
};

export const postLogout = async (): Promise<any> => {
  return await newAxiosClient.post(
    '/auth/logout',
    {},
    {
      headers: {
        'X-Access-Token': getAccessToken(),
        Authorization: `Bearer ${localStorage.getItem('refreshToken')}`
      }
    }
  );
};
